<template lang='pug' src='./invisalign.pug'></template>

<script>
import Loader from 'components/loader/loader'
import InvisalignBar from 'components/custom/custom-invisalign-bar/custom-invisalign-bar'
import InvisalignConsult from 'components/custom/custom-invisalign-consult/custom-invisalign-consult'
import InvisalignTabs from 'components/custom/custom-invisalign-tabs/custom-invisalign-tabs'
import InvislignTech from 'components/custom/custom-invisalign-tech/custom-invisalign-tech'

export default {
  name: 'invisalign',
  computed: {
    props () {
      return this.$store.state.pages.invisalign
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    InvisalignBar,
    InvisalignConsult,
    InvisalignTabs,
    InvislignTech
  }
}
</script>



// WEBPACK FOOTER //
// invisalign.vue?591b8a7a